var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pointer",on:{"click":function($event){return _vm.OrderUp()}}},[_c('img',{attrs:{"src":require("@/assets/images/elements/iconUp.svg"),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }